import { atom } from 'recoil';

export const chatCount = atom<number>({
  key: 'chatCount',
  default: 0,
});
